import { model } from "core/util";
import { CodeValue as CodeValueType, CodeValueDto } from "types";

import { LocalizedName } from "./LocalizedName";

export const CodeValue = model.createModel<CodeValueDto, CodeValueType>((json) => ({
    code: json.Code,
    localizedName: LocalizedName.fromServerList(json.Names),
}));
